import ListController from "./list/list_controller"
import Edit from "./edit/edit"
import store from '../view/edit/store'
import toast from "@components/toast/toast"

export default function ViewController(){
    BaseConstructor.call(this)
    let context = this
    let listControler = new ListController()
    let current_parameter
    this.showList = () =>{
        listControler.show()
    }

    this.hideList = () =>{
        listControler.hide()
    }

    this.showEdit = (parameter = {}) =>{
        this.hideList()
        let _edit = new Edit({parameter_id: parameter.id})
        
        _edit.on('edit-view:save', () =>{
            _edit.hide()
            listControler.reload()
            toast.success({text: "Dados salvos."})
        })

        _edit.on('edit-view:cancel', () =>{
            _edit.hide()
            listControler.reload()
        })
    }

    this.getCurrentParameter = _ =>{
        return current_parameter
    }

    this.getMeasurements = async (options, period) =>{
        await _http_v1.get("measurements/grouped?format=json", options).then(data=>{
            store.setMeasurements(data.json)
        })
    }

    init()

    function init(){
        listControler.on('edit_parameter', parameter=>{
            context.showEdit(parameter)
        })
        listControler.on('use_view', parameter=>{
            current_parameter = parameter
            context.hideList()
            context.trigger('use_view' ,current_parameter)
        })
        listControler.on('new-parameter', () =>{
            context.showEdit()
        })
        listControler.on('destroy_view', () =>{
            listControler.reload()
        })

    }
}

ViewController.prototype = Object.create(BaseConstructor.prototype)